export const trackUmamiEvent = (eventName, eventData) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.umami || typeof window.umami.track !== 'function') {
    return;
  }

  if (eventData) {
    window.umami.track(eventName, eventData);
    return;
  }

  window.umami.track(eventName);
};
